import React from 'react';
import ForgeDialogWrapper from '../../reusable/ForgeDialogWrapper/ForgeDialogWrapper.js';
import { CLOSE } from '../../../static/keyWords.js';
import PropTypes from 'prop-types';
import { ForgeAiResponseMessage, ForgeAiUserMessage } from '@tylertech/forge-ai-react';
import { normalizePythonMessage, normalizePythonQuestion } from '../../PBBStrategist/ChatbotAdapter/pbbStrategistAdapterHelpers.js';
import ReactMarkdown from 'react-markdown';
import { MODAL_TITLE } from '../aiAnalyticsHelpers.js';
import './ViewQuestionDataModal.scss';

const ViewQuestionDataModal = ({ open, data, onClose }) => {
  return (
    <ForgeDialogWrapper
      open={open}
      title={MODAL_TITLE}
      showPrimaryButton
      showSecondaryButton={false}
      primaryButtonText={CLOSE}
      handleClickPrimaryButton={() => onClose()}
      handleClose={() => onClose()}
      initiallyNotDisabled
    >
      <div className="flexContainer flexEnd">
        <ForgeAiUserMessage className="maxWidth75">
          {normalizePythonQuestion(data.question)}
        </ForgeAiUserMessage>
      </div>
      <ForgeAiResponseMessage>
        <div className="view-question-data-response">
          <ReactMarkdown>
            {normalizePythonMessage(data.answer)}
          </ReactMarkdown>
        </div>
      </ForgeAiResponseMessage>
    </ForgeDialogWrapper>
  );
};

export default ViewQuestionDataModal;

ViewQuestionDataModal.propTypes = {
  open: PropTypes.bool,
  data: PropTypes.object,
  onClose: PropTypes.func
};
